import { createSnackbarQueue } from "@rmwc/snackbar"

import "@material/snackbar/dist/mdc.snackbar.css"
import "@material/button/dist/mdc.button.css"

const queue = createSnackbarQueue()

export default queue
